import { Box, BoxProps } from "@mantine/core";
import { ReactNode } from "react";

// Pinned footer for every drawer view (list / detail / new).
const SupportFooter = ({
  children,
  ...rest
}: { children: ReactNode } & BoxProps) => (
  <Box
    p="md"
    bg="var(--mantine-color-body)"
    style={{ borderTop: "1px solid var(--mantine-color-default-border)" }}
    {...rest}
  >
    {children}
  </Box>
);

export default SupportFooter;
